import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '@consts/url.const';
import { SupportAccessModel } from '@models/support-access.model';

@Injectable({
  providedIn: 'root',
})
export class SupportAccessService {
  private readonly http = inject(HttpClient);

  public getSupportAccess(): Observable<SupportAccessModel.Document[]> {
    return this.http.get<SupportAccessModel.Document[]>(api.users.getSupportAccess);
  }

  public getAllSupportAccess(): Observable<SupportAccessModel.Document[]> {
    return this.http.get<SupportAccessModel.Document[]>(`${api.users.getSupportAccess}/admin/all`);
  }

  public createSupportAccess(
    body: SupportAccessModel.CreateRequest,
  ): Observable<SupportAccessModel.CreateCacheResponse> {
    return this.http.post<SupportAccessModel.CreateCacheResponse>(
      `${api.users.getSupportAccess}/user-support-cache`,
      body,
    );
  }

  public updateSupportAccessEnabled(
    id: string,
    body: SupportAccessModel.UpdateEnabledRequest,
  ): Observable<SupportAccessModel.Document> {
    return this.http.patch<SupportAccessModel.Document>(`${api.users.getSupportAccess}/${id}/enabled`, body);
  }

  public updateSupportAccess(
    id: string,
    body: SupportAccessModel.UpdateRequest,
  ): Observable<SupportAccessModel.Document> {
    return this.http.patch<SupportAccessModel.Document>(`${api.users.getSupportAccess}/${id}`, body);
  }

  public deleteSupportAccess(id: string): Observable<void> {
    return this.http.delete<void>(`${api.users.getSupportAccess}/${id}`);
  }
}
